module.exports = __webpack_public_path__ + "static/media/clubify_phone.2ea9a762.png";